var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AdSet",
    transform: "translate(-2831 -2674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_161",
    "data-name": "Union 161",
    d: "M17079-1562.734a3.006,3.006,0,0,1-3-3v-10.034a3.006,3.006,0,0,1,3-3h5.576a3.006,3.006,0,0,1,3,3v10.034a3.006,3.006,0,0,1-3,3Zm-.258-3.955a.89.89,0,0,0,.893.888h4.314a.89.89,0,0,0,.889-.888.89.89,0,0,0-.889-.892h-4.314A.891.891,0,0,0,17078.744-1566.689Zm0-2.673a.89.89,0,0,0,.893.888h4.314a.89.89,0,0,0,.889-.888.89.89,0,0,0-.889-.892h-4.314A.891.891,0,0,0,17078.744-1569.362Zm11.219,2.96a.89.89,0,0,1-.893-.888c0-.086-.031-8.812,0-11.57a1.681,1.681,0,0,0-.412-1.274,1.862,1.862,0,0,0-1.219-.412h-.051l-.039,0h-6.756a.891.891,0,0,1-.893-.892.891.891,0,0,1,.893-.892h6.859a3.586,3.586,0,0,1,2.414.884,3.351,3.351,0,0,1,.982,2.6c-.029,2.75,0,11.458,0,11.548a.883.883,0,0,1-.883.892Zm1.779-3.561c0-.086-.029-8.807,0-11.57a1.667,1.667,0,0,0-.416-1.274,1.84,1.84,0,0,0-1.213-.412h-.057l-.039,0h-6.752a.891.891,0,0,1-.893-.892.89.89,0,0,1,.893-.888h6.7a1.556,1.556,0,0,1,.158,0,3.619,3.619,0,0,1,2.416.884,3.358,3.358,0,0,1,.982,2.6c-.031,2.75,0,11.463,0,11.548a.886.886,0,0,1-.889.892A.888.888,0,0,1,17091.742-1569.963Z",
    transform: "translate(-14238.734 4261.867)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9151",
    "data-name": "Rectangle 9151",
    width: 28,
    height: 28,
    transform: "translate(2831 2674)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdset);
export default __webpack_public_path__ + "static/media/adset.bff6c9a336bd43ffaf0ba4409eb0e5f0.svg";
export { ForwardRef as ReactComponent };